import styled from 'styled-components';
import { rem } from 'styles/theme';

// language=SCSS prefix=*{ suffix=}
export const ContainerStyled = styled.div`
    border-radius: ${rem(8)};
    background-color: ${({ theme }) => theme.colors.tertiary.lightest};
`;
